import { forwardRef, type ButtonHTMLAttributes, type ReactNode } from "react";
import "./Chip.css";

export interface ChipProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  icon?: ReactNode;
}

export const Chip = forwardRef<HTMLButtonElement, ChipProps>(
  ({ icon, children, className = "", type = "button", ...props }, ref) => (
    <button {...props} ref={ref} type={type} className={`sk-chip ${className}`}>
      {icon && (
        <span className="sk-chip__icon" aria-hidden="true">
          {icon}
        </span>
      )}
      <span className="sk-chip__label">{children}</span>
    </button>
  ),
);
Chip.displayName = "Chip";
